import "./App.css";
import {
  Alert,
  Button,
  Card,
  Progress,
  Segmented,
  Spin,
  Statistic,
  Tag,
  Row,
  Col,
  FloatButton
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  PoweroffOutlined,
  CaretRightOutlined,
  PauseOutlined,
  ControlOutlined,
} from "@ant-design/icons";
import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, database as db } from "./firebase";
import StreamPlayer from './StreamPlayer'

const timePickerColumns = [
  [],
  [
    { label: "00", value: 0 },
    { label: "15", value: 15 },
    { label: "30", value: 30 },
    { label: "45", value: 45 },
  ],
  [
    { label: "AM", value: "am" },
    { label: "PM", value: "pm" },
  ],
];
function populateHourPicker() {
  for (let i = 1; i < 13; i++)
    timePickerColumns[0].push({ label: i.toString(), value: i });
}
populateHourPicker();

function SwitchUI() {
  const navigate = useNavigate();

  const [valveStatus, setValveStatus] = useState({
    icon: <InfoCircleOutlined />,
    connected: false,
    loading: true,
    state: false,
    disabled: false,
    offline: false,
  });

  useEffect(() => {
    if (!auth.currentUser) navigate("/login");

    refresh();
  });

  const refresh = async() => {
    setTimeout(async() => {
      const res = await fetch("https://home-server.avi-portfolio.net/valve/status");
      if(res.status == 200) {
        const resp = await res.json();
        setValveStatus({...valveStatus, loading: false, offline: false, state: resp.state, disabled: resp.disabled, connected: true});
      } else {
        setValveStatus({icon: <CheckCircleOutlined />, 
          loading: false, 
          offline: true, 
          connected: false
        });
      }
    }, 2000);
  }

  const toggleControl = async () => {
    setValveStatus({...valveStatus, loading: true});
    const res = await fetch("https://home-server.avi-portfolio.net/valve/setState?state=" + !valveStatus.state)
    if(res.status == 200) {
      const resp = await res.text();
      if(resp == "true") {
        setValveStatus({...valveStatus, state: true});
      } else if(resp == "false") {
        setValveStatus({...valveStatus, state: false});
      }
    }
  };

  const toggleDisabled = async () => {
    setValveStatus({...valveStatus, loading: true});
    fetch("https://home-server.avi-portfolio.net/valve/setDisabled?disabled=" + !valveStatus.disabled)
  };

  const stateIndicator = () => {
    var icon = <PauseOutlined/>;
    var btnTxt = "Pause";
    if(valveStatus.disabled) {
      icon = <CaretRightOutlined />;
      btnTxt = "Resume";
    } 

    var powerBtnColor = "#00e384";
    if(!valveStatus.state) powerBtnColor = "#dc4446";
    if(valveStatus.disabled) powerBtnColor = "#808080";

    return (
      <Spin spinning={valveStatus.loading}>
        <Row gutter={[16, {xs: 8, sm: 16}]}>
            <Col span={24} >
            <PoweroffOutlined
              className="powerBtn"
              style={{ color: powerBtnColor }}
              onClick={toggleControl}
              />
            </Col>
            <Col span={6} offset={16}>
              <Button type="primary" icon={icon} onClick={toggleDisabled}>
                {btnTxt}
              </Button>
            </Col>
        </Row>
      </Spin>
    );
  };

  const cardTitle = (title, sensorStatus) => {
    let color = "processing";
    let statusMsg = "connecting...";
    if (!sensorStatus.loading) {
      color = "success";
      if ("offline" in sensorStatus && sensorStatus.offline) color = "warning";
      else if (!sensorStatus.connected) color = "error";

      statusMsg = "online";
      if ("offline" in sensorStatus && sensorStatus.offline)
        statusMsg = "offline";
      else if (!sensorStatus.connected) 
        statusMsg = "disconnected";
    }
    return (
      <div className="card-title">
        <span>{title}</span>
        <Tag icon={sensorStatus.icon} color={color} className="status">
          {statusMsg}
        </Tag>
      </div>
    );
  };

  return (
    <div className="cam-dashboard">
      <FloatButton icon={<ControlOutlined />} onClick={() => navigate("/switch")}></FloatButton>
      <StreamPlayer/>
      <Card
        title={cardTitle("Valve", valveStatus)}
        bordered={false}
        className="sprinkler-control-card"
      >
        {stateIndicator()}
      </Card>
    </div>
  );
}

export default SwitchUI;
